export class SetStuck {
  static readonly type = '[Stuck] Set stuck';
  constructor(public isStuck: boolean) {}
}
